import { makeStyles } from "@material-ui/styles";
import { TIMELINE_MONTH_HEADER_HEIGHT } from "@utils";

const useStyle = makeStyles(() => ({
  firstPadding: {
    paddingTop: TIMELINE_MONTH_HEADER_HEIGHT + 4,
  },
}));

export default useStyle;
